export var DataType;
(function (DataType) {
    DataType[DataType["Int32"] = 1] = "Int32";
    DataType[DataType["Float"] = 2] = "Float";
    DataType[DataType["Bool"] = 4] = "Bool";
    DataType[DataType["String"] = 8] = "String";
})(DataType || (DataType = {}));
export function calcMaxBitIndex(dataType) {
    if (dataType === DataType.Int32) {
        return 31;
    }
}
